import { render } from "./bet-start-stop-pop.vue?vue&type=template&id=0c8cedf9&ts=true"
import script from "./bet-start-stop-pop.vue?vue&type=script&lang=ts"
export * from "./bet-start-stop-pop.vue?vue&type=script&lang=ts"

import "./bet-start-stop-pop.vue?vue&type=style&index=0&id=0c8cedf9&lang=scss"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__